
import { useState } from 'react';

export function TestimonialsSection() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      name: 'Ivey Atkinson',
      location: 'Kalamazoo, MI',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'She was my realtor when I bought my house and when I sold it! She was patient with me every step of the way! I appreciate you so much!',
      rating: 5,
      property: 'Home Purchase & Sale'
    },
    {
      name: 'Latosha House',
      location: 'Saginaw, MI',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'Shantonya assisted us with the purchase of our new home. She was very professional and hardworking. She even worked some late nights and followed up with our bank when things moved slow. Thank you for everything! We love our new home!',
      rating: 5,
      property: 'New Home Purchase'
    },
    {
      name: 'Jovan Willis',
      location: 'Grand Rapids, MI',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'Shantonya did a great job for us. We were able to buy a new home and sell our old home quickly. She is professional and very welcoming.',
      rating: 5,
      property: 'Home Purchase & Sale'
    },
    {
      name: 'Tamara Hayles',
      location: 'Virginia',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'Shantonya was a complete professional. She was always available to answer any questions we may have had during the process of buying and selling our home in Virginia. Since we were not in Michigan, she could not officially be our agent. However, that did not stop her from making sure to find us the perfect realtor in Virginia to make the process seamless. Hands down would recommend her to anyone ready to sell, purchase or both. True professional, ready to work hard for you!',
      rating: 5,
      property: 'Relocation Assistance'
    },
    {
      name: 'Joy Arrington',
      location: 'Southfield, MI',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'If you ever want an educated and stress free home buying experience, Shantonya is the lady to share it with. She is so Awesome!! While working with a limited amount of time she helped me find a home that met my needs with her recommendations and careful execution. I can\'t wait to buy another home just because.',
      rating: 5,
      property: 'Home Purchase'
    },
    {
      name: 'Christopher Ellis',
      location: 'Detroit, MI',
      image: 'https://static.readdy.ai/image/f4572b6e15e16776c888605c49b58c9c/388f46a828b0f9c175308d978ca8bf49.png',
      text: 'Shantonya Scott exceeded my expectations greatly! I\'m a fast mover when conducting business and I\'m in awe of how fast she moves when conducting business for me! She\'s the only realtor I\'m going to recommend to people that I know residential or commercial! She is so 5 star!!!! Good job OT!!😉',
      rating: 5,
      property: 'Commercial Purchase'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            What My Clients Say
          </h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Real stories from real families who trusted me with their most important real estate decisions. Your success is my greatest achievement.
          </p>
        </div>
        
        <div className="relative">
          <div className="bg-white rounded-lg shadow-xl p-8 lg:p-12 max-w-4xl mx-auto">
            <div className="flex flex-col lg-flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <img 
                  src={testimonials[currentTestimonial].image}
                  alt={testimonials[currentTestimonial].name}
                  className="w-32 h-32 rounded-full object-cover object-top shadow-lg"
                />
              </div>
              
              <div className="flex-1 text-center lg:text-left">
                <div className="flex justify-center lg:justify-start mb-4">
                  {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                  ))}
                </div>
                
                <blockquote className="text-lg lg:text-xl text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonials[currentTestimonial].text}"
                </blockquote>
                
                <div>
                  <div className="font-bold text-black text-lg">
                    {testimonials[currentTestimonial].name}
                  </div>
                  <div className="text-gray-600 mb-2">
                    {testimonials[currentTestimonial].location}
                  </div>
                  <div className="text-sm text-yellow-600 font-medium">
                    {testimonials[currentTestimonial].property}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button 
            onClick={prevTestimonial}
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white text-black rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>
          
          <button 
            onClick={nextTestimonial}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white text-black rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>
        
        <div className="flex justify-center mt-8 space-x-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                index === currentTestimonial ? 'bg-white' : 'bg-gray-600'
              }`}
            />
          ))}
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">100%</div>
            <div className="text-gray-300">Client Satisfaction Rate</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">50+</div>
            <div className="text-gray-300">Happy Families Served</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">5.0★</div>
            <div className="text-gray-300">Average Client Rating</div>
          </div>
        </div>
        
      </div>
    </section>
  );
}
